import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/general/Avatar';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IconDownload } from '@tabler/icons-react';
import downloadPDF from 'components/general/PreFormPDF';

const Table = ({ data, handleDeleteBtn = () => {} }) => {
  const navigate = useNavigate();
  const {
    user: { user },
  } = useSelector((state) => state.auth);

  const [filteredData, setFilteredData] = useState(data);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  useEffect(() => {
    if (sortConfig.key !== null) {
      const sortedData = [...filteredData].sort((a, b) => {
        const factor = sortConfig.direction === 'ascending' ? 1 : -1;
        if (sortConfig.key === 'dateOfCommission') {
          return (new Date(a[sortConfig.key]) - new Date(b[sortConfig.key])) * factor;
        } else {
          return (a[sortConfig.key] ?? '').localeCompare(b[sortConfig.key] ?? '') * factor;
        }
      });
      setFilteredData(sortedData);
    } else {
      setFilteredData(data);
    }
  }, [sortConfig, data]);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handleEditClick = (row) => {
    if (row.submittedBy?.id === user?.id) {
      navigate(`/allforms/form/edit/${row.id}`);
    } else if (row.reportingTo?.id === user?.id && row.status === 'pending') {
      navigate(`/allforms/form/review/${row.id}`);
    } else {
      navigate(`/allforms/form/view/${row.id}`);
    }
  };

  return (
    <>
      <div className="card">
        <div className="table-responsive">
          <table className="table card-table table-vcenter text-nowrap datatable pre-table">
            <tbody>
              <tr>
                <th onClick={() => handleSort('submittedBy.name')}>
                  Username{' '}
                  {sortConfig.key === 'submittedBy.name' && (
                    <span>{sortConfig.direction === 'ascending' ? '▲' : '▼'}</span>
                  )}
                </th>
                <th onClick={() => handleSort('dateOfCommission')}>
                  Commissioning Date{' '}
                  {sortConfig.key === 'dateOfCommission' && (
                    <span>{sortConfig.direction === 'ascending' ? '▲' : '▼'}</span>
                  )}
                </th>
                <th onClick={() => handleSort('stationName')}>
                  Station Name{' '}
                  {sortConfig.key === 'stationName' && (
                    <span>{sortConfig.direction === 'ascending' ? '▲' : '▼'}</span>
                  )}
                </th>
                <th onClick={() => handleSort('documentNo')}>
                  Document ID{' '}
                  {sortConfig.key === 'documentNo' && (
                    <span>{sortConfig.direction === 'ascending' ? '▲' : '▼'}</span>
                  )}
                </th>
                <th onClick={() => handleSort('chargerId')}>
                  OCPP ID{' '}
                  {sortConfig.key === 'chargerId' && (
                    <span>{sortConfig.direction === 'ascending' ? '▲' : '▼'}</span>
                  )}
                </th>
                <th className="text-center">Actions</th>
              </tr>
              {filteredData.length > 0 ? (
                filteredData.map((row) => (
                  <tr key={row.id}>
                    <td className="user_name">
                      <div className="d-flex align-items-center gap-2">
                        <Avatar
                          role={row?.submittedBy?.role}
                          name={`${row?.submittedBy?.name} ${
                            row?.submittedBy?.lastName ? row?.submittedBy?.lastName : ''
                          }`}
                        />
                        <span>{`${row?.submittedBy?.name} ${
                          row?.submittedBy?.lastName ? row?.submittedBy?.lastName : ''
                        }`}</span>
                      </div>
                    </td>
                    <td>{row.dateOfCommission}</td>
                    <td>{row.stationName ?? '-'}</td>
                    <td>{row.documentNo ?? '-'}</td>
                    <td>{row.chargerId ?? '-'}</td>
                    <td>
                      <div className="d-flex gap-2 all_btn justify-content-end align-items-center">
                        <div className={`pending_btn ${row.status.toLowerCase()}_status`}>
                          {row.status === 'pending'
                            ? 'Pending'
                            : row.status === 'approved'
                            ? 'Approved'
                            : row.status === 'rework'
                            ? 'Re-Work'
                            : row.status === 'commission'
                            ? 'Ready to Commission'
                            : 'Draft'}
                        </div>
                        <div
                          className="edit_btn"
                          onClick={() => {
                            handleEditClick(row);
                          }}
                        >
                          {row.submittedBy?.id === user?.id
                            ? row.status === 'pending' || row.status === 'approved'
                              ? 'View'
                              : 'Edit'
                            : row.reportingTo?.id === user?.id && row.status === 'pending'
                            ? 'Review'
                            : 'View'}
                        </div>
                        <div
                          className="delete_btn"
                          onClick={() => {
                            handleDeleteBtn(row.id);
                          }}
                        >
                          Delete
                        </div>
                        <div className="download_btn" onClick={() => downloadPDF(row)}>
                          <IconDownload />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="user_name" colSpan={6}>
                    {' '}
                    No records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

Table.propTypes = {
  data: PropTypes.array,
  handleDeleteBtn: PropTypes.func,
};

export default Table;
